import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../mock';
import { MessageCircle } from 'lucide-react';
import { Button } from './ui/button';

export const FAQ = () => {
  const handleWhatsApp = () => {
    window.open('https://wa.me/918667644336?text=I have a question about your services', '_blank');
  };

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          <div className="inline-block bg-[#D4AF37]/10 text-[#D4AF37] px-4 py-2 rounded-full text-sm font-semibold mb-4">
            FAQ
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#0F1419] mb-6 playfair">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-600 text-lg">
            Find answers to common questions about our services, processes, and more.
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq) => (
            <AccordionItem
              key={faq.id}
              value={`item-${faq.id}`}
              className="border-2 border-gray-100 rounded-2xl px-6 hover:border-[#D4AF37]/30 transition-colors"
            >
              <AccordionTrigger className="text-left hover:no-underline py-6">
                <span className="text-lg font-semibold text-[#0F1419] playfair pr-4">
                  {faq.question}
                </span>
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Still Have Questions CTA */}
        <div className="mt-16 text-center bg-gradient-to-br from-gray-50 to-white border-2 border-gray-100 rounded-3xl p-12">
          <div className="bg-[#D4AF37]/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
            <MessageCircle className="w-8 h-8 text-[#D4AF37]" />
          </div>
          <h3 className="text-2xl font-bold text-[#0F1419] mb-4 playfair">
            Still Have Questions?
          </h3>
          <p className="text-gray-600 mb-6 max-w-md mx-auto">
            Can't find the answer you're looking for? Our team is here to help you with any queries.
          </p>
          <Button
            onClick={handleWhatsApp}
            className="bg-[#D4AF37] hover:bg-[#B8941F] text-white px-8 py-6 text-lg font-semibold"
          >
            <MessageCircle className="w-5 h-5 mr-2" />
            Chat with Us on WhatsApp
          </Button>
        </div>
      </div>
    </section>
  );
};